import { render } from "./CoursewarePdf.vue?vue&type=template&id=46fae0b5&scoped=true"
import script from "./CoursewarePdf.vue?vue&type=script&lang=js"
export * from "./CoursewarePdf.vue?vue&type=script&lang=js"

import "./CoursewarePdf.vue?vue&type=style&index=0&id=46fae0b5&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fae0b5"]])

export default __exports__